import React, { useMemo, useEffect, useState, useCallback, useContext } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import { makeStyles, lighten } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faPlus, faStar, faBook, faPlay, faLink } from '@fortawesome/pro-solid-svg-icons';
import Typography from '@material-ui/core/Typography';
import sanitizeHtml from 'sanitize-html';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Popover from '@material-ui/core/Popover';
import { Pill } from '@scoir/pills';
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var Labels = _ref => {
  var children = _ref.children;
  return children ? /*#__PURE__*/React.createElement(Box, {
    p: 2
  }, children) : null;
};

var transpanentImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAhGVYSWZNTQAqAAAACAAFARIAAwAAAAEAAQAAARoABQAAAAEAAABKARsABQAAAAEAAABSASgAAwAAAAEAAgAAh2kABAAAAAEAAABaAAAAAAAAAGAAAAABAAAAYAAAAAEAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAAaADAAQAAAABAAAAAQAAAADlRRw6AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNi4wLjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgoZXuEHAAAAC0lEQVQIHWP4DwQACfsD/Qy7W+cAAAAASUVORK5CYII=';

var borderRadius = _ref => {
  var isAtTopOfCard = _ref.isAtTopOfCard;
  return isAtTopOfCard ? '4px 4px 0 0' : '0';
};
var backgroundImage = _ref2 => {
  var imageSrc = _ref2.imageSrc;
  return "url(\"".concat(imageSrc, "\")");
};

var getPaletteColor = (theme, color, defaultString) => {
  switch (color) {
    case 'primary':
      return theme.palette.primary.main;

    case 'secondary':
      return theme.palette.secondary.main;

    case 'error':
      return theme.palette.error.main;

    case 'warning':
      return theme.palette.warning.main;

    case 'success':
      return theme.palette.success.main;

    case 'info':
      return theme.palette.info.main;

    default:
      return defaultString;
  }
};

var getIconColor = function getIconColor(theme) {
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primary';
  return theme && Object.keys(theme).length ? getPaletteColor(theme, color, 'inherit') : 'inherit';
};
var getIconBackgroundColor = function getIconBackgroundColor(theme) {
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'primary';
  return lighten(theme && Object.keys(theme).length ? getPaletteColor(theme, color, '#656565') : '#656565', 0.95);
};
var useStyles$9 = makeStyles(theme => {
  return {
    iconContainer: {
      color: _ref3 => {
        var _color = _ref3.color;
        return getIconColor(theme, _color);
      },
      backgroundColor: _ref4 => {
        var color = _ref4.color;
        return getIconBackgroundColor(theme, color);
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '22px',
      width: '100%',
      height: '160px',
      borderRadius: borderRadius
    },
    imageContainer: {
      width: '100%',
      height: 0,
      paddingTop: '100%',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundImage: backgroundImage,
      borderRadius: borderRadius,
      backgroundColor: '#f5f5f5'
    }
  };
});

var Media = _ref5 => {
  var icon = _ref5.icon,
      color = _ref5.color,
      imageSrc = _ref5.imageSrc,
      isAtTopOfCard = _ref5.isAtTopOfCard,
      emptyState = _ref5.emptyState,
      contentImgAlt = _ref5.contentImgAlt;
  var classes = useStyles$9({
    color: color,
    isAtTopOfCard: isAtTopOfCard,
    imageSrc: imageSrc
  });
  if (imageSrc) return /*#__PURE__*/React.createElement("img", {
    className: classes.imageContainer,
    src: transpanentImg,
    alt: contentImgAlt
  });
  if (icon) return /*#__PURE__*/React.createElement("div", {
    className: classes.iconContainer
  }, icon);
  if (emptyState) return emptyState;
  return null;
};

var MIN_WIDTH = 40;
var MAX_WIDTH = 100;

var getRandomWidth = () => {
  var pct = Math.floor(Math.random() * (MAX_WIDTH - MIN_WIDTH + 1) + MIN_WIDTH);
  return "".concat(pct, "%");
};

var useStyles$8 = makeStyles({
  linePlaceholder: {
    height: '1.4em',
    marginRight: '0.5em',
    marginBottom: '0.5em',
    background: '#f5f5f5',
    display: 'inline-block'
  }
});

var LinePlaceholder = () => {
  var classes = useStyles$8();
  var width = useMemo(() => getRandomWidth(), []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.linePlaceholder,
    style: {
      width: width
    }
  });
};

var Skeleton = _ref => {
  var _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? 1 : _ref$lines;
  var linePlaceholders = useMemo(() => {
    var arr = [];

    for (var i = 0; i < lines; i++) {
      arr.push( /*#__PURE__*/React.createElement(LinePlaceholder, {
        key: i
      }));
    }

    return arr;
  }, [lines]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, linePlaceholders);
};

var isTextBeyondMax = (scrollHeight, len) => scrollHeight > len;

var truncate = (str, limit) => {
  if (!str) return '';
  var content = str.trim();

  if (str.length > limit) {
    return "".concat(content.slice(0, limit).trim(), "...");
  }

  return content;
};

var TruncatedText = _ref => {
  var text = _ref.text,
      limit = _ref.limit,
      maxHeight = _ref.maxHeight,
      className = _ref.className;

  var _React$useState = React.useState(limit),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      length = _React$useState2[0],
      setLength = _React$useState2[1];

  var _React$useState3 = React.useState(text),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      textString = _React$useState4[0],
      setTextString = _React$useState4[1];

  var wrapperRef = /*#__PURE__*/React.createRef();
  useEffect(() => {
    if (textString !== text) {
      setLength(limit);
      setTextString(text);
    }

    if (text) {
      var formattedText = truncate(text, length);
      var cur = wrapperRef.current;

      if (cur && formattedText.length > 3) {
        if (isTextBeyondMax(cur.scrollHeight, maxHeight)) {
          setLength(length - 3);
        }
      }
    }
  }, [text, limit, textString, length, maxHeight, wrapperRef]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(className),
    ref: wrapperRef,
    dangerouslySetInnerHTML: {
      __html: truncate(text, length)
    }
  });
};

// @ts-ignore
var sanitize = value => {
  return sanitizeHtml(value, {
    allowedTags: [],
    allowedAttributes: []
  });
};

var useStyles$7 = makeStyles({
  title: {
    width: '100%',
    paddingTop: '4px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  }
});

var Content = _ref => {
  var title = _ref.title,
      body = _ref.body,
      icon = _ref.icon,
      minHeight = _ref.minHeight,
      showSkeleton = _ref.showSkeleton,
      truncateTitle = _ref.truncateTitle,
      truncateBody = _ref.truncateBody;
  var classes = useStyles$7();
  var hasContent = title || body;
  var formattedBody = body ? sanitize(body) : undefined;
  var displayBody = truncateBody ? /*#__PURE__*/React.createElement(TruncatedText, {
    text: formattedBody,
    limit: 120,
    maxHeight: 152
  }) : formattedBody;
  return !hasContent && !showSkeleton ? null : /*#__PURE__*/React.createElement(Box, {
    p: 2,
    width: "100%",
    minHeight: minHeight
  }, /*#__PURE__*/React.createElement(Box, {
    pb: 1,
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    className: cn(_defineProperty({}, classes.title, truncateTitle))
  }, title || showSkeleton && /*#__PURE__*/React.createElement(Skeleton, null)), icon), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    component: 'span'
  }, displayBody || showSkeleton && /*#__PURE__*/React.createElement(Skeleton, {
    lines: 3
  })));
};

var defaultState = {
  open: false
};
var Context = /*#__PURE__*/React.createContext(defaultState);

var CardExpandContextWrapper = _ref => {
  var children = _ref.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var onToggle = useCallback(() => setOpen(!open), [open]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: {
      open: open,
      onToggle: onToggle
    }
  }, children);
};

var useStyles$6 = makeStyles({
  root: {
    overflowY: 'auto',
    overflowX: 'hidden',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  }
});

var ScrollWrapper = _a => {
  var maxHeight = _a.maxHeight,
      children = _a.children,
      className = _a.className,
      rest = __rest(_a, ["maxHeight", "children", "className"]);

  var classes = useStyles$6();
  return /*#__PURE__*/React.createElement("div", Object.assign({}, rest, {
    className: cn(className, classes.root),
    style: {
      maxHeight: maxHeight
    }
  }), children);
};

/* eslint-disable @typescript-eslint/no-explicit-any */
var getDisplayName = WrappedComponent => WrappedComponent.displayName || WrappedComponent.name || 'Component';

var withContext = (WrappedComponent, Context) => {
  var WrappedComponentWithContext = props => {
    var additionalProps = useContext(Context);
    return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({}, additionalProps, props));
  };

  WrappedComponentWithContext.displayName = "WithContext(".concat(getDisplayName(WrappedComponent), ")");
  return WrappedComponentWithContext;
};

var useStyles$5 = makeStyles({
  hideBottomBorder: {
    borderBottom: 'none'
  }
});
var ExpandSection = _ref => {
  var open = _ref.open,
      children = _ref.children,
      maxHeight = _ref.maxHeight,
      _ref$showDivider = _ref.showDivider,
      showDivider = _ref$showDivider === void 0 ? true : _ref$showDivider;
  var classes = useStyles$5();
  return /*#__PURE__*/React.createElement(Collapse, {
    "in": open,
    timeout: "auto",
    unmountOnExit: true
  }, showDivider ? /*#__PURE__*/React.createElement(Divider, null) : null, /*#__PURE__*/React.createElement(ScrollWrapper, {
    maxHeight: maxHeight,
    className: showDivider ? classes.hideBottomBorder : undefined
  }, children));
};
var ExpandSection$1 = withContext(ExpandSection, Context);

var useStyles$4 = makeStyles(theme => ({
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    width: '18px',
    height: '18px',
    boxSizing: 'content-box'
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  }
}));
var ExpandButton = _ref => {
  var open = _ref.open,
      onToggle = _ref.onToggle;
  var classes = useStyles$4();
  return /*#__PURE__*/React.createElement(IconButton, {
    className: cn(classes.expand, _defineProperty({}, classes.expandOpen, open)),
    onClick: onToggle,
    "aria-expanded": open,
    "aria-label": "show more"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faAngleDown
  }));
};
var ExpandButton$1 = withContext(ExpandButton, Context);

var useStyles$3 = makeStyles(theme => ({
  root: {
    zIndex: 0,
    position: 'relative',
    width: '100%',
    maxWidth: _ref => {
      var _maxWidth = _ref.maxWidth;
      return _maxWidth || '352px';
    },
    margin: '0 auto'
  },
  headerPills: {
    margin: theme.spacing(2, 2, 0),
    padding: 0
  },
  title: {
    fontSize: '16px',
    lineHeight: '24px'
  },
  subtitle: {
    fontSize: '14px',
    lineHeight: '20px'
  },
  linkHeader: {
    color: theme.palette.text.primary,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
      '& $title': {
        textDecoration: 'underline'
      }
    }
  },
  headerBorder: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  },
  selectableHover: {
    top: 0,
    left: 0,
    zIndex: 2,
    opacity: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    position: 'absolute',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    background: 'rgba(100,100,100,0.1)',
    border: '2px solid',
    borderRadius: '4px',
    transition: '0.25s all ease-out',
    color: 'transparent',
    borderColor: 'transparent',
    '&:hover': {
      opacity: 0.4
    },
    '&:focus': {
      opacity: 0.4
    }
  },
  selectableColors: {
    background: 'rgba(255,255,255,0.8)',
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main
  },
  selectedCenter: {
    background: '#ffffff',
    borderRadius: '50%',
    display: 'none',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    boxShadow: '0 0 5px 5px rgb(0 0 0 / 5%)',
    height: '80px',
    width: '80px',
    justifyItems: 'center'
  },
  showing: {
    display: 'flex'
  },
  selected: {
    color: theme.palette.success.main,
    borderColor: theme.palette.success.main,
    opacity: 1,
    '&:hover': {
      opacity: 0.8
    },
    '&:focus': {
      opacity: 0.8
    }
  },
  editControls: {
    zIndex: 3,
    position: 'relative'
  },
  actions: {
    position: 'relative',
    zIndex: 3
  }
}));
var DefaultCardHeaderWrapper = _ref2 => {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
var LinkCardHeaderWrapper = _ref3 => {
  var headerToLink = _ref3.headerToLink,
      children = _ref3.children;
  var classes = useStyles$3({});
  return /*#__PURE__*/React.createElement(Link, {
    to: headerToLink,
    className: classes.linkHeader
  }, children);
};

var CardContentWrapper = _ref4 => {
  var onClick = _ref4.onClick,
      children = _ref4.children;
  return onClick ? /*#__PURE__*/React.createElement(CardActionArea, {
    onClick: onClick
  }, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

var ComplexCard = _a => {
  var _cn;

  var className = _a.className,
      maxWidth = _a.maxWidth,
      headerProps = _a.headerProps,
      hasHeaderDivider = _a.hasHeaderDivider,
      headerToLink = _a.headerToLink,
      _a$cardHeaderWrapper = _a.cardHeaderWrapper,
      CardHeaderWrapper = _a$cardHeaderWrapper === void 0 ? headerToLink ? LinkCardHeaderWrapper : DefaultCardHeaderWrapper : _a$cardHeaderWrapper,
      headerPills = _a.headerPills,
      customMedia = _a.customMedia,
      mediaIcon = _a.mediaIcon,
      mediaIconColor = _a.mediaIconColor,
      mediaImageSrc = _a.mediaImageSrc,
      mediaEmptyState = _a.mediaEmptyState,
      contentTitle = _a.contentTitle,
      contentBody = _a.contentBody,
      contentImgAlt = _a.contentImgAlt,
      contentIcon = _a.contentIcon,
      contentMinHeight = _a.contentMinHeight,
      contentTitleTruncate = _a.contentTitleTruncate,
      contentBodyTruncate = _a.contentBodyTruncate,
      contentOnClick = _a.contentOnClick,
      showContentEmptyState = _a.showContentEmptyState,
      expandContent = _a.expandContent,
      expandContentMaxHeight = _a.expandContentMaxHeight,
      eventComponent = _a.eventComponent,
      editControls = _a.editControls,
      onSelectCard = _a.onSelectCard,
      isSelected = _a.isSelected,
      showSelectableStyles = _a.showSelectableStyles,
      labels = _a.labels,
      actions = _a.actions,
      rest = __rest(_a, ["className", "maxWidth", "headerProps", "hasHeaderDivider", "headerToLink", "cardHeaderWrapper", "headerPills", "customMedia", "mediaIcon", "mediaIconColor", "mediaImageSrc", "mediaEmptyState", "contentTitle", "contentBody", "contentImgAlt", "contentIcon", "contentMinHeight", "contentTitleTruncate", "contentBodyTruncate", "contentOnClick", "showContentEmptyState", "expandContent", "expandContentMaxHeight", "eventComponent", "editControls", "onSelectCard", "isSelected", "showSelectableStyles", "labels", "actions"]);

  var classes = useStyles$3({
    maxWidth: maxWidth
  });
  var hasContent = contentTitle || contentBody || false;
  var onSelectBySpace = useCallback(e => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      onSelectCard && onSelectCard();
    }
  }, [onSelectCard]);
  return /*#__PURE__*/React.createElement(Card, Object.assign({
    className: cn(classes.root, className)
  }, rest), editControls && /*#__PURE__*/React.createElement("div", {
    className: classes.editControls
  }, editControls), headerPills ? /*#__PURE__*/React.createElement(CardContent, {
    className: classes.headerPills
  }, headerPills) : null, headerProps && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardHeaderWrapper, {
    headerToLink: headerToLink
  }, /*#__PURE__*/React.createElement(CardHeader, Object.assign({
    className: hasHeaderDivider ? classes.headerBorder : '',
    titleTypographyProps: {
      className: classes.title
    },
    subheaderTypographyProps: {
      className: classes.subtitle,
      color: 'textSecondary'
    }
  }, headerProps))), /*#__PURE__*/React.createElement(Labels, null, labels)), /*#__PURE__*/React.createElement(CardContentWrapper, {
    onClick: contentOnClick
  }, customMedia || /*#__PURE__*/React.createElement(Media, {
    emptyState: mediaEmptyState,
    icon: mediaIcon,
    color: mediaIconColor,
    imageSrc: mediaImageSrc,
    isAtTopOfCard: !headerProps,
    contentImgAlt: contentImgAlt
  }), /*#__PURE__*/React.createElement(Content, {
    title: contentTitle,
    body: contentBody,
    icon: contentIcon,
    minHeight: contentMinHeight,
    showSkeleton: showContentEmptyState,
    truncateTitle: contentTitleTruncate,
    truncateBody: contentBodyTruncate
  })), eventComponent, !headerProps && /*#__PURE__*/React.createElement(Labels, null, labels), !eventComponent && (actions || expandContent) && /*#__PURE__*/React.createElement(CardExpandContextWrapper, null, /*#__PURE__*/React.createElement(ExpandSection$1, {
    maxHeight: expandContentMaxHeight,
    showDivider: hasContent
  }, expandContent), hasContent ? /*#__PURE__*/React.createElement(Divider, null) : null, /*#__PURE__*/React.createElement(CardActions, {
    className: classes.actions,
    disableSpacing: true
  }, actions, expandContent && /*#__PURE__*/React.createElement(ExpandButton$1, null))), onSelectCard && /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    role: "button",
    "aria-haspopup": "dialog",
    "aria-label": "Select card",
    className: cn(classes.selectableHover, (_cn = {}, _defineProperty(_cn, classes.selected, isSelected), _defineProperty(_cn, classes.selectableColors, showSelectableStyles), _cn)),
    onClick: onSelectCard,
    onKeyDown: e => onSelectBySpace(e)
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(classes.selectedCenter, _defineProperty({}, classes.showing, showSelectableStyles))
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "lg",
    icon: isSelected ? faCheckCircle : faPlus
  })), /*#__PURE__*/React.createElement(Box, {
    pt: 1
  }, isSelected ? 'Selected' : 'Select'))));
};

var useStyles$2 = makeStyles(theme => {
  var _pillTrunc;

  return {
    pillButton: {
      /** Override mui button styles */
      '& .MuiButton-iconSizeMedium': {
        alignItems: 'center',
        width: 'auto',
        marginTop: 0
      },
      '& .MuiButton-iconSizeMedium > *:first-child': {
        fontSize: 14
      }
    },
    popover: {
      maxHeight: '300px'
    },
    pillTrunc: (_pillTrunc = {
      maxWidth: '145px'
      /* About 25 characters */

    }, _defineProperty(_pillTrunc, theme.breakpoints.down('md'), {
      maxWidth: 110
    }), _defineProperty(_pillTrunc, "textOverflow", 'ellipsis'), _defineProperty(_pillTrunc, "textWrap", 'nowrap'), _defineProperty(_pillTrunc, "overflow", 'hidden'), _defineProperty(_pillTrunc, "margin", 0), _pillTrunc)
  };
});
var PreferencesPill = _ref => {
  var preferences = _ref.preferences,
      allMet = _ref.allMet,
      _ref$countMet = _ref.countMet,
      countMet = _ref$countMet === void 0 ? 0 : _ref$countMet;
  var classes = useStyles$2();

  var _useState = useState({
    ref: null,
    open: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      preferencePopover = _useState2[0],
      setPreferencePopover = _useState2[1];

  var pluralizePreference = allMet || countMet && countMet > 1 ? 'Preferences' : 'Preference';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pill, {
    className: classes.pillButton,
    color: "secondary",
    // @ts-ignore TODO: update Pills to accept ref
    ref: preferencePopover.ref,
    component: Button,
    onClick: e => setPreferencePopover({
      ref: e.currentTarget,
      open: !preferencePopover.open
    }),
    startIcon: allMet ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faStar
    }) : null
  }, "Meets ", allMet ? 'All' : countMet, " ", pluralizePreference), /*#__PURE__*/React.createElement(Popover, {
    className: classes.popover,
    open: preferencePopover.open,
    anchorEl: preferencePopover.ref,
    onClose: () => setPreferencePopover({
      ref: null,
      open: false
    }),
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/React.createElement(List, {
    dense: true
  }, preferences.map((item, idx) => /*#__PURE__*/React.createElement(ListItem, {
    key: idx
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: item
  }))))));
};
var MajorsPill = _ref2 => {
  var majors = _ref2.majors;
  var classes = useStyles$2();

  var _useState3 = useState({
    ref: null,
    open: false
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      majorsPopover = _useState4[0],
      setMajorsPopover = _useState4[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Pill, {
    className: classes.pillButton,
    color: "info",
    // @ts-ignore TODO: update Pills to accept ref
    ref: majorsPopover.ref,
    component: Button,
    onClick: e => setMajorsPopover({
      ref: e.currentTarget,
      open: !majorsPopover.open
    }),
    startIcon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faBook
    })
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.pillTrunc
  }, majors[0]), " ", "".concat(majors.length > 1 ? "+".concat(majors.length - 1) : '')), /*#__PURE__*/React.createElement(Popover, {
    className: classes.popover,
    open: majorsPopover.open,
    anchorEl: majorsPopover.ref,
    onClose: () => setMajorsPopover({
      ref: null,
      open: false
    }),
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/React.createElement(List, {
    dense: true
  }, majors.map((item, idx) => /*#__PURE__*/React.createElement(ListItem, {
    key: idx
  }, /*#__PURE__*/React.createElement(ListItemText, {
    primary: item
  }))))));
};

var useStyles$1 = makeStyles(theme => ({
  icon: {
    color: theme.palette.text.secondary,
    display: 'flex',
    alignItems: 'center'
  }
}));

var LinkIcon = _ref => {
  var url = _ref.url;
  var classes = useStyles$1();
  var expressions = {
    youtube: /^https?:\/\/(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/,
    vimeo: /^https?:\/\/(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|)([0-9]{5,11})$/
  };
  var isVideo = expressions.youtube.test(url) || expressions.vimeo.test(url);
  return /*#__PURE__*/React.createElement(Icon, {
    className: classes.icon
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "xs",
    // @ts-ignore - fortawesome ts error
    icon: isVideo ? faPlay : faLink,
    title: isVideo ? 'Content Contains Video' : 'Content Contains External Link'
  }));
};

var useStyles = makeStyles(theme => ({
  listRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },
  li: {
    padding: theme.spacing(1),
    backgroundColor: 'rgba(116, 145, 255, 0.08)',
    borderRadius: theme.spacing(1),
    fontWeight: 300
  }
}));

var ExpandableContent = _ref => {
  var dataSets = _ref.dataSets;
  var classes = useStyles();

  var getOverview = data => /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    key: "overview"
  }, data.map((point, i) => /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    key: i
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, point.title), /*#__PURE__*/React.createElement(Typography, null, point.stat))));

  var getHighlights = data => {
    var list = /*#__PURE__*/React.createElement(List, {
      className: classes.listRoot
    }, data.map((point, i) => /*#__PURE__*/React.createElement(ListItem, {
      className: classes.li,
      key: i
    }, point)));
    return /*#__PURE__*/React.createElement(Box, {
      mt: 3,
      key: "highlights"
    }, /*#__PURE__*/React.createElement(Typography, null, "Our Highlights"), list);
  };

  var content = dataSets.map(data => {
    if (data.points.length) {
      if (data.type === 'highlights') return getHighlights(data.points);
      if (data.type === 'overview') return getOverview(data.points);
    }
  });
  return /*#__PURE__*/React.createElement(Box, {
    p: 2
  }, content);
};

export { ComplexCard, ExpandableContent, LinkIcon, MajorsPill, PreferencesPill };
//# sourceMappingURL=index.module.js.map
